import { z } from 'zod';
const passwordRegEx =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>/?]).{8,}$/; // eslint-disable-line

export const emailSchema = z
  .string({ message: 'email is required' })
  .email({ message: 'Invalid email' });

export const newPasswordSchema = z
  .string({ message: 'Password must be at least 8 characters' })
  .min(8, { message: 'Password must be at least 8 characters' })
  .max(32, { message: 'Password cannot exceed 32 characters' })
  .refine((val) => passwordRegEx.test(val), {
    message:
      'Password must include uppercase, lowercase, number, and special character',
  });

//schema for password reset form
export const tokenRegEx = /^[0-9]{6}$/;
export const passwordResetSchema = z
  .object({
    password: newPasswordSchema,
    confirm_password: z.string({ message: 'Confirm password' }),
    token: z
      .string({ message: 'Reset token is required' })
      .regex(tokenRegEx, { message: 'Invalid token' }),
    // .max(6, { message: 'Invalid token' })
    // .min(6, { message: 'Invalid token' }),
  })
  .refine((data) => data.password === data.confirm_password, {
    path: ['confirm_password'],
    message: 'Passwords do not match',
  });

export const passwordSchema = z
  .string()
  .min(8, { message: 'Password must be at least 8 characters' })
  .max(32, { message: 'Password cannot exceed 32 characters' });
/*
                                .regex(/[A-Z]/, {
                                message: 'Password must contain at least one uppercase letter',
                                })
                                .regex(/[a-z]/, {
                                message: 'Password must contain at least one lowercase letter',
                                })
                                .regex(/[0-9]/, {
                                message: 'Password must contain at least one number',
                                })
                                .regex(/[\W_]/, {
                                message: 'Password must contain at least one special character',
                                })*/

export const confirmPasswordSchema = passwordSchema;

export const firstNameSchema = z
  .string()
  .min(1, { message: 'First name is required' });

export const lastNameSchema = z
  .string()
  .min(1, { message: 'Last name is required' });

const phoneNoRegEx = /^\+?[0-9]{10,15}$/;
export const phoneSchema = z.string().regex(phoneNoRegEx, {
  message:
    'Phone must be a valid international number (10 to 15 digits, optional +)',
});

export const refCodeSchema = z.string().optional();

export const tokenSchema = z.string().min(6, { message: 'Invalid token' });
